<div class="helping-hand-wrapper">
    <img src="../../assets/icons/illustration-feature-related-reputation-manager-active@3x.svg" alt="">
    <div class="content">
        <div class="heading">{{"GENERAL.HELPING_HAND_TITLE" | translate}}</div>
        <div class="description">{{"GENERAL.HELPING_HAND_DESCRIPTION" | translate}}</div>
        <a class="link" href="{{'GENERAL.HELPING_HAND_URL' | translate}}" target="_blank">{{"GENERAL.HELPING_HAND_LINK" | translate}}</a>
    </div>
</div>
